const cartUpsell = () => {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((data) => {
      updateUpsell(data.item_count, data.total_price);
    });
};

async function getCart() {
  return await fetch("/cart.js")
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
}

const displayShippingSuccess = () => {
  let moneyDrawer = document.querySelector(".cart-upsell__message-drawer");
  moneyDrawer.innerHTML = `Woo! You got free shipping!`;
};

const updateCheckoutButtons = async () => {
  const items = document.getElementsByClassName("cart__checkout-wrapper");
  const cartMinimum = 15000;
  const currentTotal = await getCart();
  const neededTotal = cartMinimum - currentTotal.total_price;
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  for (let i = 0; i < items.length; i++) {
    if (currentTotal.total_price < cartMinimum) {
      items[
        i
      ].innerHTML = `<button type="submit" disabled name="checkout" data-terms-required="false" class="btn cart__checkout" style="width:100%">
          Checkout
              </button><div style="margin-top: 9px;font-size:14px;font-weight:600; text-align: center;">Our Wholesale order minimum is $150, please add ${formatter.format(
        neededTotal / 100
      )} more product to the cart to checkout</div>`;
    } else {
      items[
        i
      ].innerHTML = `<button type="submit" name="checkout" data-terms-required="{{ settings.cart_terms_conditions_enable }}" class="btn cart__checkout">
                Checkout
              </button>`;
    }
  }
};

async function updateUpsell() {
  const data = await getCart();
  let container = document.querySelector(".cart-upsell");
  // let drawercontainer = document.querySelector(".cart-drawer-upsell");

  if (data.total_price >= 80000) {
    if (container) {
      container.style.display = "none";
    }
    showToast(true);
  } else {
    if (container) {
      container.style.display = "block";
    }
    showToast(false);
  }
  const priceformatted = ((80000 - data.total_price) / 100).toLocaleString(
    "en-us",
    {
      style: "currency",
      currency: "usd",
    }
  );
  let money = document.querySelector(".cart-upsell__message");
  let moneyDrawer = document.querySelector(".cart-upsell__message-drawer");
  // let count = document.querySelectorAll(".cart-upsell__button");
  // const pairsleft = 4 - data.item_count;

  // count[i].textContent = `select ${pairsleft} more ${pairsleft > 1 ? "pairs" : "pair"}`;
  // count[i].textcontent = `select another pair!`;

  // if priceformatted <= 0, displaysuccess
  if ((80000 - data.total_price) / 100 <= 0) {
    displayShippingSuccess();
    return;
  }
  if (money) {
    money.textContent = `you are ${priceformatted} away from free shipping!`;
  }
  moneyDrawer.innerHTML = `you are <span style="color: #FFFFFF">${priceformatted}</span> away from free shipping!`;

  updateCheckoutButtons(data.total_price);
}

const changeQuantity = (change) => {
  let product = JSON.parse(window.sessionStorage.getItem("recommendedProduct"));
  if (change === "plus") {
    product.quantity += 1;
  } else if (change === "minus") {
    product.quantity -= 1;
  }
  displayRecommendedProduct(product);
};

const displayRecommendedProduct = (product) => {
  let drawercontainer = document.querySelector(".cart-drawer-upsell__inner");

  if (!product) {
    return;
  }

  product.price = (product.price / 100).toLocaleString("en-us", {
    style: "currency",
    currency: "usd",
  });

  drawercontainer.innerHTML = `<div class="cart-drawer-upsell-recommended">
  <div class="cart-drawer-upsell-item">
    <a class="cart-drawer-upsell-image"
       href="${product.url}">
      <img src="${product.images[0]}" />
    </a>
    <div class="cart-drawer-recommended-info">
      <div class="cart-drawer-recommended-info-inside" >
        <span style="font-size: 16px;"><a href="${product.url}">${product.title}</a></span>
      </div>
      <div class="cart-drawer-recommendation-button" >
        <div>
          <div class="cart__item--qty">
            <div class="js-qty__wrapper particular_btn">
              <label for="cart_updates_${product.variants[0].id}"
                     class="hidden-label"></label>
              <input type="text"
                     name="updates[]"
                     class="js-qty__num cart-drawer-upsell__item"
                     value="6"
                     min="6"
                     pattern="[0-9]*"
                     data-rtid="${product.variants[0].id}">
              <button type="button"
                      onclick="modifyProductQty(event, 'minus')"
                      class="js-qty__adjust js-qty__adjust--minus"
                      id="cart-drawer-upsell__minus"
                      aria-label="{{ 'cart.general.reduce_quantity' | t }}">
                <svg aria-hidden="true"
                     focusable="false"
                     role="presentation"
                     class="icon icon-minus"
                     viewBox="-1 0 20 20">
                  <path fill="#444"
                        d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z" />
                </svg>
                <span class="icon__fallback-text"
                      aria-hidden="true">&minus;</span>
              </button>
              <button type="button"
                      onclick="modifyProductQty(event, 'plus')"
                      class="js-qty__adjust js-qty__adjust--plus"
                      id="cart-drawer-upsell__plus"
                      style="right: 6px;"
                      aria-label="{{ 'cart.general.increase_quantity' | t }}">
                <svg aria-hidden="true"
                     focusable="false"
                     role="presentation"
                     class="icon icon-plus"
                     viewBox="0 0 20 20">
                  <path fill="#444"
                        d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z" />
                </svg>
                <span class="icon__fallback-text"
                      aria-hidden="true">+</span>
              </button>
            </div>
          </div>

        </div>
        <div class="cart-drawer-recommendation-price">${product.price}</div>
      </div>
    </div>
  </div>
  <button id="cart-drawer-upsell-b2b__add-to-cart-button" data-product="${product.variants[0].id}"
          style="padding: 12px; margin-bottom:-10px;"
          onclick="addProductToCart(event)"
          class="btn cart__checkout btn-particular">Add to Cart</button>
</div>`;
};

const addProductToCart = (e) => {
  e.preventDefault();
  const productId = e.target.dataset.product;
  const itemInput = $(".cart-drawer-upsell__item");
  const productQty = itemInput.val();
  const formData = {
    quantity: productQty,
    id: productId,
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (response.status == 200) {
        window.location.href = "/cart";
        return response.json();
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};

const modifyProductQty = (e, type) => {
  const itemInput = $(".cart-drawer-upsell__item");
  let productId = itemInput.data.product;
  let productQty = Number(itemInput.val());
  console.log(productQty);

  if (type === "minus") {
    productQty -= 6;
    if (productQty < 6) {
      productQty = 6;
    }
  } else {
    productQty += 6;
  }
  return $(itemInput).val(productQty);
};

const updateDrawerUpsell = async () => {
  const data = await getCart();
  let recommendedProduct = {};
  await getProductRecommendations(data.items[0].product_id).then((data) => {
    return (recommendedProduct = data.products[data.products.length - 1]);
  });
  let drawercontainer = document.querySelector(".cart-drawer-upsell");

  // if (data.total_price >= 4000) {
  //   drawercontainer.style.display = "none";
  //   showToast(true);
  // } else {
  //   drawercontainer.style.display = "block";
  //   showToast(false);
  // }
  const priceformatted = ((80000 - data.total_price) / 100).toLocaleString(
    "en-us",
    {
      style: "currency",
      currency: "usd",
    }
  );

  if (recommendedProduct) {
    recommendedProduct.quantity = 1;
    window.sessionStorage.setItem(
      "recommendedProduct",
      JSON.stringify(recommendedProduct)
    );
    displayRecommendedProduct(recommendedProduct);
  }
};

const getProductRecommendations = async (productID, limit = 1) => {
  const data = fetch(
    `/recommendations/products.json?product_id=${productID}&limit=${limit}`
  ).then((res) => res.json());
  return data;
};

function showToast(bool) {
  // Get the snackbar DIV
  let toast = document.querySelector("#toast");

  if (bool) {
    // Add the "show" class to DIV
    toast.classList.add("showToast");

    // After 3 seconds, remove the show class from DIV
    setTimeout(function() {
      toast.classList.remove("showToast");
    }, 3000);
  } else {
    toast.classList.remove("showToast");
  }
}

// window.onload = function() {
//     updateUpsell()
// }

document.addEventListener("page:loaded", function() {
  // Page has loaded and theme assets are ready
  updateUpsell();
  updateDrawerUpsell();
});
